export default __webpack_public_path__ + "static/black-gravel-bananatex-4abbefb761d3c6d2aab1a5cfc5bde614.png";